import { Box, Flex, Icon, Image } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React, { useState } from "react"
import { BsCheck } from "react-icons/bs"
import { CloudImage } from "../../CloudProviderTypes"
import CloudImageBrowserImageBroken from "./CloudImageBrowserImageBroken"

interface Props {
  image: CloudImage
  onImageSelect: (id: EntityId) => void
  isSelected: boolean
}

const CloudImageBrowserImage: React.FC<Props> = ({
  image,
  isSelected,
  onImageSelect,
}) => {
  const [hasErrorLoadingImage, setHasErrorLoadingImage] = useState(false)

  if (hasErrorLoadingImage) {
    return <CloudImageBrowserImageBroken />
  }

  return (
    <Box position="relative" height="165px">
      <Flex
        position="relative"
        cursor="pointer"
        className="vnz-image-item"
        overflow="hidden"
        onClick={() => onImageSelect(image.id)}
        borderRadius={8}
        transition="0.2s"
        width="100%"
        height="100%"
        transform={isSelected ? "scale(0.95)" : "scale(1)"}
        boxShadow={
          isSelected ? "0 0 0 3px var(--chakra-colors-primary-600)" : "none"
        }
        _hover={{
          transform: isSelected ? "scale(0.95)" : "scale(0.98)",
        }}
      >
        <Image
          src={image.thumbnailUrl}
          width="100%"
          height="100%"
          objectFit="cover"
          onError={() => setHasErrorLoadingImage(true)}
        />
        <Flex
          position="absolute"
          top="-30px"
          right="-30px"
          opacity={isSelected ? 1 : 0}
          transform={isSelected ? "translate(0, 0)" : "translate(10px, -10px)"}
          transition="all 0.2s ease-in-out"
        >
          <Flex
            width="60px"
            height="60px"
            backgroundColor="primary.600"
            transform="rotate(45deg)"
            boxShadow="md"
          />
        </Flex>
        <Flex
          position="absolute"
          top="0px"
          right="0px"
          opacity={isSelected ? 1 : 0}
          transition="all 0.2s ease-in-out"
        >
          <Icon as={BsCheck} boxSize={6} color="white" />
        </Flex>
      </Flex>
    </Box>
  )
}

export default CloudImageBrowserImage
